<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer/table">客户管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="'/customer/detail/' + id">客户详情({{customerName}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :showHeader="false">
     <h3>客户 {{customerName}} 当前余额：{{customerBalance}}</h3>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="onExportSearch"
                   size="small">流水导出
        </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="客户ID"></el-table-column>
        <el-table-column prop="projectid"
                         label="项目ID"></el-table-column>
        <el-table-column prop="amount"
                         label="消费金额"></el-table-column>
        <el-table-column prop="updatetime"
                         label="消费时间"></el-table-column>
        <el-table-column prop="taskid"
                         label="相关任务"></el-table-column>
        <el-table-column prop="managementfee"
                         label="管理费用">
          <template slot-scope="scope">{{scope.row.managementfee}}(管理费率: {{scope.row.managementrate * 100}}%)</template>
        </el-table-column>
        <el-table-column prop="desc"
                         label="备注"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      customerName: null,
      customerBalance: null,
      id: this.$route.params.id,
      search: {
        id: this.$route.params.id
      },
      exportHeader: [
        {
          key: 'id',
          text: '客户ID',
        },
        {
          key: 'projectid',
          text: '项目ID',
        },
        {
          key: 'amount',
          text: '消费金额',
        },
        {
          key: 'updatetime',
          text: '消费时间',
        },
        {
          key: 'taskid',
          text: '相关任务',
        },
        {
          key: 'managementfee',
          text: '管理费用',
        },
        {
          key: 'desc',
          text: '备注',
        }
      ]
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      this.setCustomer()
      params.id = this.$route.params.id
      return request.page('getCustomerBalanceFlowTable', params)
    },
    setCustomer () {
      request.common('getCustomerBalanceDetail', {id: this.$route.params.id}).then(({data}) => {
        this.customerName = data.name
        this.customerBalance = data.balance
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          if (data.total > 0) {
            for (let i in data.data) {
              if (data.data.hasOwnProperty(i)) {
                data.data[i].managementfee += `(管理费率: ${data.data[i].managementrate * 100}%)`
              }
            }
          }

          return data
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/customer/pages/CustomerBalanceFlowTable.vue